import { PARTNER360_NAMESPACE } from 'legacy/lut/features/partner360/common/constants'

export const PARTNER360_LANDING_NAMESPACE = `${PARTNER360_NAMESPACE}/landing`

// Async thunk constants
export const REQUEST_LANDING_DATA = `${PARTNER360_LANDING_NAMESPACE}/requestLandingData`
export const REQUEST_INIT_PLAN = `${PARTNER360_LANDING_NAMESPACE}/initPlan`
export const REQUEST_LANDING_PARTNER_SEARCH = `${PARTNER360_LANDING_NAMESPACE}/requestLandingPartnerSearch`
export const REFRESH_LANDING_DATA = `${PARTNER360_LANDING_NAMESPACE}/refreshLandingData`
